import styled from '@emotion/styled';
import { size, space } from '../../styles';
import { buildCSSWithLength } from '../../styles';
import { StackProps as CommonStackProps } from './types';

export interface StackProps extends Omit<CommonStackProps, 'spacing'> {
  inline?: boolean;
  flex?: React.CSSProperties['flex'];
  direction?: React.CSSProperties['flexDirection'];
  wrap?: React.CSSProperties['flexWrap'];
  align?: React.CSSProperties['alignItems'];
  justify?: React.CSSProperties['justifyContent'];
  gap?: React.CSSProperties['gap'];
}

export const Stack = styled.div<StackProps>`
  display: ${({ inline }) => (inline ? 'inline-flex' : 'flex')};
  ${({ flex }) => flex !== undefined && `flex: ${flex}`};
  ${({ direction }) => direction && `flex-direction: ${direction}`};
  ${({ wrap }) => wrap && `flex-wrap: ${wrap}`};
  ${({ align }) => align !== undefined && `align-items: ${align}`};
  ${({ justify }) => justify !== undefined && `justify-content: ${justify}`};
  ${({ gap }) => gap !== undefined && (typeof gap === 'number' ? buildCSSWithLength('gap', gap) : `gap: ${gap}`)};

  ${size};
  ${space};
`;
